<template>
    <b-modal id="SendHistoryModal" size="lg" hide-footer hide-header @show="loadLogs">
        <div class="sh-header">
            <span>HISTÓRICO DE ENVIOS — HOJE</span>
            <span class="sh-close" @click="$bvModal.hide('SendHistoryModal')">✕</span>
        </div>
        <div class="sh-body">
            <table class="sh-table">
                <thead>
                    <tr>
                        <th>Data/Hora</th>
                        <th>Remetente</th>
                        <th>Destinatário</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="logs.length === 0">
                        <td colspan="4" class="sh-empty">Nenhum envio registrado hoje.</td>
                    </tr>
                    <tr v-for="(log, i) in logs" :key="i">
                        <td>{{ log.createdAt }}</td>
                        <td>{{ log.senderName || '—' }}</td>
                        <td>{{ log.to }}</td>
                        <td>
                            <span :class="log.success ? 'sh-ok' : 'sh-fail'">
                                {{ log.success ? 'OK' : 'Falha' }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="sh-footer">
            <button class="sh-btn-cancel" @click="$bvModal.hide('SendHistoryModal')">FECHAR</button>
        </div>
    </b-modal>
</template>

<script>
import axios from 'axios';
import { urlMainAPI } from '../../../global.js';

export default {
    name: 'SendHistoryModal',
    data() {
        return {
            logs: []
        };
    },
    methods: {
        async loadLogs() {
            try {
                const { data } = await axios.get(`${urlMainAPI}/getdailysendlog`);
                this.logs = Array.isArray(data) ? data : [];
            } catch {
                this.logs = [];
            }
        }
    }
};
</script>

<style scoped>
.sh-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 18px;
    border-bottom: 1px solid #eee;
    font-weight: bold;
    font-size: 13px;
    color: #333;
    text-transform: uppercase;
}
.sh-close { cursor: pointer; color: #999; font-size: 16px; }
.sh-body { padding: 18px; }
.sh-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.sh-table th { background: #f5f5f5; padding: 9px 10px; border-bottom: 2px solid #ddd; text-align: left; color: #555; }
.sh-table td { padding: 9px 10px; border-bottom: 1px solid #eee; color: #333; }
.sh-empty { text-align: center; color: #999; font-style: italic; }
.sh-ok { color: #26806c; font-weight: bold; }
.sh-fail { color: #bf0603; font-weight: bold; }
.sh-footer {
    padding: 12px 18px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
}
.sh-btn-cancel {
    background: #fff;
    color: #f37021;
    border: 1px solid #f37021;
    padding: 8px 22px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    font-size: 12px;
    text-transform: uppercase;
}
</style>
